import type { ReactNode } from "react";
import { Link } from "react-router-dom";

type PrimaryButtonProps = Readonly<{
  children: ReactNode;
  to: string;
  className?: string;
}>;

export function PrimaryButton({ children, to, className }: PrimaryButtonProps) {
  const classes = ["primary-button", className].filter(Boolean).join(" ");
  return (
    <Link className={classes} to={to}>
      <span>{children}</span>
      <span aria-hidden="true">→</span>
    </Link>
  );
}
